import React from "react";
import { Card, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { GRADIENTS, GLASS_CARD } from "../../utils/designTokens";

const StyledCard = styled(Card)(() => ({
  background: GLASS_CARD.background,
  backdropFilter: GLASS_CARD.backdropFilter,
  borderRadius: GLASS_CARD.borderRadius,
  position: "relative",
  color: "#fff",
  overflow: "visible",
  boxShadow: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    zIndex: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: GLASS_CARD.borderRadius,
    padding: "2px",
    background: GRADIENTS.accent,
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    pointerEvents: "none",
  },
  "& > .MuiBox-root": {
    position: "relative",
    zIndex: 1,
  },
  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0 8px 24px rgba(37, 99, 235, 0.2)",
  },
}));

const CardTitle = styled(Typography)(() => ({
  background: GRADIENTS.text,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: 700,
  fontSize: "1.5rem",
  marginBottom: "10px",
  display: "inline-block",
}));

const GlassCard = React.memo(({ title, children, sx, ...props }) => {
  return (
    <StyledCard sx={sx} {...props}>
      <Box p={`${GLASS_CARD.padding}`}>
        {title && <CardTitle variant="h5">{title}</CardTitle>}
        {children}
      </Box>
    </StyledCard>
  );
});

export default GlassCard;
